"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rfidTagConfigTypes = void 0;
exports.rfidTagConfigTypes = {
    SET_ERROR: 'RFID TAG CONFIG TYPES SET ERROR',
    ON_MUTATION_CLICK: 'RFID TAG CONFIG TYPES ON MUTATION',
    TOGGLE_SUCCESS_MODAL: 'RFID TAG CONFIG TYPES SET SUCCESS MODAL',
};
